import React from "react";

const Card = (props) => {
  const {
    children,
    className,
    paddingLeftRight = "px-4",
    paddingTopBottom = "py-6",
  } = props;
  return (
    <div
      style={{
        boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
      }}
      className={`rounded-[4px] shadow-lg ${paddingTopBottom} ${paddingLeftRight} ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
